const STORAGE_KEY = 'devello_signup_plan_v1';
const MAX_AGE_MS = 1000 * 60 * 60 * 24 * 7; // 7 days

/**
 * @returns {'free'|'pro'|null}
 */
export function readSignupPlanIntent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.plan !== 'free' && parsed?.plan !== 'pro') return null;
    if (typeof parsed.ts !== 'number' || Date.now() - parsed.ts > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed.plan;
  } catch {
    return null;
  }
}

/** @param {'free'|'pro'} plan */
export function writeSignupPlanIntent(plan) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ plan, ts: Date.now() }));
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearSignupPlanIntent() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Read intent once (e.g. after email verification) and remove it from storage. */
export function consumeSignupPlanIntent() {
  const plan = readSignupPlanIntent();
  clearSignupPlanIntent();
  return plan;
}
